
const state = {
  data: {},
  description: '',
  id: null,
  lesson_alias_id: undefined,
  title: '',
  training_module_id: undefined,
}

export const requiredFields = [
  { key: 'description' },
  { key: 'title' },
  { key: 'training_module_id' },
]

export default state
